var _defs, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _path7, _circle4, _circle5, _circle6, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8CyberSecurity50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c7ZdtdClpdZcn~mCluv5Za",
    x1: 38.586,
    x2: 41.414,
    y1: 35.586,
    y2: 38.414,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 38",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4fe5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2eb7ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c7ZdtdClpdZcn~mCluv5Zb",
    x1: 41.586,
    x2: 44.414,
    y1: 29.586,
    y2: 32.414,
    xlinkHref: "#c7ZdtdClpdZcn~mCluv5Za"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c7ZdtdClpdZcn~mCluv5Zc",
    x1: 35.586,
    x2: 38.414,
    y1: 41.586,
    y2: 44.414,
    xlinkHref: "#c7ZdtdClpdZcn~mCluv5Za"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c7ZdtdClpdZcn~mCluv5Zd",
    x1: 14.71,
    x2: 33.433,
    y1: 743.481,
    y2: 792.256,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 11",
    gradientTransform: "translate(0 -752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.076,
    stopColor: "#ffda1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb705"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c7ZdtdClpdZcn~mCluv5Ze",
    x1: 6.586,
    x2: 9.414,
    y1: 35.586,
    y2: 38.414,
    xlinkHref: "#c7ZdtdClpdZcn~mCluv5Za"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c7ZdtdClpdZcn~mCluv5Zf",
    x1: 3.586,
    x2: 6.414,
    y1: 29.586,
    y2: 32.414,
    xlinkHref: "#c7ZdtdClpdZcn~mCluv5Za"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c7ZdtdClpdZcn~mCluv5Zg",
    x1: 9.586,
    x2: 12.414,
    y1: 41.586,
    y2: 44.414,
    xlinkHref: "#c7ZdtdClpdZcn~mCluv5Za"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c7ZdtdClpdZcn~mCluv5Zh",
    cx: 18.136,
    cy: 15.147,
    r: 15.887,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 34",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#64717c",
    d: "M18,44H11a1,1,0,0,1,0-2h7V33a1,1,0,0,1,2,0v9A2.002,2.002,0,0,1,18,44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#64717c",
    d: "M5,32a1,1,0,0,1-1-1V27a2.002,2.002,0,0,1,2-2h7a1,1,0,0,1,0,2H6v4A1,1,0,0,1,5,32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#64717c",
    d: "M13,38H8a1,1,0,0,1,0-2h5V28a1,1,0,0,1,2,0v8A2.002,2.002,0,0,1,13,38Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#64717c",
    d: "M37,44H30a2.002,2.002,0,0,1-2-2V33a1,1,0,0,1,2,0v9h7a1,1,0,0,1,0,2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#64717c",
    d: "M43,32a1,1,0,0,1-1-1V27H35a1,1,0,0,1,0-2h7a2.002,2.002,0,0,1,2,2v4A1,1,0,0,1,43,32Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#64717c",
    d: "M40,38H35a2.002,2.002,0,0,1-2-2V28a1,1,0,0,1,2,0v8h5a1,1,0,0,1,0,2Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 37,
    r: 2,
    fill: "url(#c7ZdtdClpdZcn~mCluv5Za)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 31,
    r: 2,
    fill: "url(#c7ZdtdClpdZcn~mCluv5Zb)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 43,
    r: 2,
    fill: "url(#c7ZdtdClpdZcn~mCluv5Zc)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c7ZdtdClpdZcn~mCluv5Zd)",
    d: "M40.10526,9.4C30.154,9.4,30.01442,4,24,4S17.846,9.4,7.89474,9.4A.89771.89771,0,0,0,7,10.3v8.1A15.19355,15.19355,0,0,0,7.44111,22C10.06805,32.8063,23.618,39.9163,23.618,39.9163A1.08136,1.08136,0,0,0,24,40a1.16913,1.16913,0,0,0,.382-.0837S37.932,32.8063,40.55889,22A15.19355,15.19355,0,0,0,41,18.4V10.3A.89771.89771,0,0,0,40.10526,9.4Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 37,
    r: 2,
    fill: "url(#c7ZdtdClpdZcn~mCluv5Ze)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 31,
    r: 2,
    fill: "url(#c7ZdtdClpdZcn~mCluv5Zf)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 43,
    r: 2,
    fill: "url(#c7ZdtdClpdZcn~mCluv5Zg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,16a3.99718,3.99718,0,0,1,1.5,7.70337V27.5a1.5,1.5,0,0,1-3,0V23.70337A3.99718,3.99718,0,0,1,24,16m0-1a4.9974,4.9974,0,0,0-2.5,9.326V27.5a2.5,2.5,0,0,0,5,0V24.326A4.9974,4.9974,0,0,0,24,15Z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,16a3.99718,3.99718,0,0,1,1.5,7.70337V27.5a1.5,1.5,0,0,1-3,0V23.70337A3.99718,3.99718,0,0,1,24,16m0-.5a4.49712,4.49712,0,0,0-2,8.52646V27.5a2,2,0,0,0,4,0V24.02646A4.49712,4.49712,0,0,0,24,15.5Z",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c7ZdtdClpdZcn~mCluv5Zh)",
    d: "M28,20a4,4,0,1,0-5.5,3.70337V27.5a1.5,1.5,0,0,0,3,0V23.70337A3.99652,3.99652,0,0,0,28,20Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8CyberSecurity50);
export default __webpack_public_path__ + "static/media/icons8-cyber-security-50.71079fe347e679724a2b238e597c3034.svg";
export { ForwardRef as ReactComponent };